import React, { useEffect, useState } from "react";
import { Button, Input } from "reactstrap";
import { ButtonWithLoader } from "../../core";

export default function OtpBaseComponent(props) {
  const [timer, setTimer] = useState(30);
  const { otp, updateOtp, isresetOtp, verifyLoader, verifyOtp, resendOtp } = props;

  useEffect(() => {
    document.querySelector("input[name=num-1]").focus();
    setInterval(() => {
      if (timer > 0) {
        setTimer((timer) => timer - 1);
      }
    }, 1000);
  }, []);

  function handleChange(e) {
    const { maxLength, value, name } = e.target;
    const [otpName, otpIndex] = name.split("-");

    if (value.length >= maxLength) {
      if (parseInt(otpIndex, 10) < 4) {
        const nextInput = document.querySelector(
          `input[name=num-${parseInt(otpIndex, 10) + 1}]`
        );
        if (nextInput !== null) {
          nextInput.focus();
        }
      }
    }
    if (value === "") {
      if (parseInt(otpIndex, 10) > 0) {
        const nextInput = document.querySelector(
          `input[name=num-${parseInt(otpIndex, 10) - 1}]`
        );
        if (nextInput !== null) {
          nextInput.focus();
        }
      }
    }
    let tempOtp = otp;
    tempOtp += value;
    updateOtp(tempOtp);
  }

  function checkBackspace(e) {
    if (e.keyCode === 8) {
      resetOtp();
    }
  }

  function resetOtp(isEdit) {
    for (let i = 1; i <= 4; i++) {
      let inputField = document.querySelector(`input[name=num-${i}]`);
      inputField.value = "";
    }
    updateOtp("");
    if (!isEdit) document.querySelector("input[name=num-1]").focus();
  }

  useEffect(() => {
    if (isresetOtp) {
      resetOtp();
    }
  }, [isresetOtp]);

  const handleEnterKeyPress = (e) => {
    if (e.charCode === 13) {
      verifyOtp();
    }
  }

  return (
    <>
      <p className="mt-4 mb-2 subtext">Enter verification code here</p>
      <div className="input-group otp-group">
        <Input
          name="num-1"
          type="text"
          maxLength="1"
          onChange={(e) => handleChange(e)}
          onKeyDown={(e) => checkBackspace(e)}
          inputMode="numeric"
          pattern="[0-9]*"
          className="otp-ip"
        />
        <Input
          name="num-2"
          type="text"
          maxLength="1"
          onChange={(e) => handleChange(e)}
          onKeyDown={(e) => checkBackspace(e)}
          inputMode="numeric"
          pattern="[0-9]*"
          className="otp-ip"
        />
        <Input
          name="num-3"
          type="text"
          maxLength="1"
          onChange={(e) => handleChange(e)}
          onKeyDown={(e) => checkBackspace(e)}
          inputMode="numeric"
          pattern="[0-9]*"
          className="otp-ip"
        />
        <Input
          name="num-4"
          type="text"
          maxLength="1"
          onChange={(e) => handleChange(e)}
          onKeyDown={(e) => checkBackspace(e)}
          inputMode="numeric"
          pattern="[0-9]*"
          className="otp-ip"
          onKeyPress={(e) => handleEnterKeyPress(e)}
        />
      </div>
      {timer > 0 ? (
        <p className="resend">
          Resend OTP in <span className="time">{timer}</span> seconds
        </p>
      ) : (
        <p className="resent-otp" onClick={resendOtp}>
          Resend OTP
        </p>
      )}
      <div className="btn-holder">
          <Button 
            isLoading={verifyLoader}
            disabled={otp.length !== 4}
            onClick={verifyOtp}
          >
            Verify
          </Button>
    </div>
    </>
  )
}